import { NgModule } from '@angular/core';
import { DynamicRenderComponentsModule } from '@ups/xplat/web/forms/dynamic-render';
import { DynamicRenderSafetyComponentsModule } from '@ups/xplat/web/forms/dynamic-render-safety';

const MODULES = [
  DynamicRenderComponentsModule,
  DynamicRenderSafetyComponentsModule,
];

@NgModule({
  imports: [...MODULES],
  declarations: [],
  exports: [...MODULES],
})
export class DynamicRenderModule {}
